import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import Header from '../partials/Header/Header';
import Tabs from '../partials/Tabs/Tabs';
import QuestionsAnswers from '../partials/QuestionsAnswers/QuestionsAnswers';
import Links from '../partials/Links/Links';
import DataProdact from '../partials/DataProdact/DataProdact';
import MessageNoProdact from '../partials/MessageNoProdact/MessageNoProdact';
import Config from '../../../../Config';
import { getMyProductAsync } from '../EquipmentMineAsyncThunk';
import { reportDWH } from '../EquipmentMineSlice';


function EquipmentMain(props) {
 const { context } = props;
  const [isShowPage, setIsShowPage] = useState(false);
  const hasEquipment = props.equipmentsTv.length > 0 || props.equipmentsInternet.length > 0;
  const hasProduct = props.haveTv || props.haveInternet;
  const showTabs = hasEquipment || hasProduct;
    
     useEffect(() => {
        // Image-background photo on mobile/desktop
        document.documentElement.style.setProperty('--support-topics-bg-web', `url(${Config.epiBaseUrl + props.epiData?.imageDes?.expandedValue?.url })`);
        document.documentElement.style.setProperty('--support-topics-bg-mobile', `url(${Config.epiBaseUrl + props.epiData?.imageMobile?.expandedValue?.url })`);
       
        const fetchResult = async () => {
            setIsShowPage(false);
            const result = await props.getMyProductAsync(); 
            setIsShowPage(true);
            props.reportDWH({ actionType: 'MyEquipment Page', status: 'Completed', messageText: 'MyEquipment Page Displayed' });
            if(props.mesError !== 0 ){
                props.reportDWH({ actionType: 'MyEquipment Page', status: 'Error', messageText: 'General Error' });
            };
        };
        fetchResult(); 
        }, []);

    return (
        <div className='container-equipment-main'>
            <div className='image-background'>
                <Header></Header>
                {showTabs && <Tabs></Tabs>}
                { ((!props.selectTabProdact || props.selectTabProdact.length === 0) && isShowPage) &&
                    <MessageNoProdact isShowPage={isShowPage} />
                }
                 {(props.selectTabProdact.length > 0 ) &&<div className='layout'> <DataProdact isShowPage={isShowPage}></DataProdact> </div>
                }
            </div>
            {/* <div className='equipment-main-hr'></div> */}
            <Links></Links>
            {/* <div className='equipment-main-hr'></div> */}
            <QuestionsAnswers context={context}></QuestionsAnswers>
        </div>
    );
}

const mapStateToProps = (state) => {
  return {
    epiData: state.equipmentMinePage.epiData,
    selectTabProdact:state.equipmentMinePage.selectTabProdact,
    equipmentsTv: state.equipmentMinePage.equipmentsTv,
    equipmentsInternet: state.equipmentMinePage.equipmentsInternet,
    mesError:state.equipmentMinePage.mesError,
    haveTv: state.equipmentMinePage.haveTv,
    haveInternet: state.equipmentMinePage.haveInternet,
  };
};

const mapDispatchToProps = {
    getMyProductAsync,
    reportDWH
};

export default connect(mapStateToProps, mapDispatchToProps)(EquipmentMain);
